import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import ACTION_TYPES from './action-types.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'
import { CONSTANTS as MESSAGE_CONSTANTS } from '@/js/helper/message-center-constants.js'
import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'

export default [
  store => {
    if (!store.getters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGE_STATUS_URL}`]) {
      throw new Error(`Missing MESSAGES_STATUS Url!`)
    }

    store.dispatch(`${STORE_MODULES.MESSAGES}/${ACTION_TYPES.FETCH_STATUS}`)

    if (MESSAGE_CONSTANTS.MESSAGE_STATUS_INTERVAL > 0) {
      setInterval(() => {
        if (
          store.getters[`${STORE_MODULES.MESSAGES}/MESSAGES_STATUS_${REQUEST_STATE.STATE_PENDING}`]
        ) {
          console.debug('Skip Message Status fetching.')
          return
        }
        store.dispatch(`${STORE_MODULES.MESSAGES}/${ACTION_TYPES.FETCH_STATUS}`)
      }, 1000 * 60 * MESSAGE_CONSTANTS.MESSAGE_STATUS_INTERVAL)
    }
  },
]
